import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (language) => {
    localStorage.setItem('language', language);
    i18n.changeLanguage(language);
  };

  return (
    <div className="language-switcher">
      <i className="icon-globe" />
      <span 
        className={i18n.language === 'nl' ? 'active' : ''} 
        onClick={() => changeLanguage('nl')}
      >
        NL
      </span>
      <span className="divider">|</span>
      <span 
        className={i18n.language === 'en' ? 'active' : ''} 
        onClick={() => changeLanguage('en')}
      >
        EN
      </span>
    </div>
  );
};

export default LanguageSwitcher;
